import { Injectable } from '@angular/core';
import { IbundleData } from '../interfaces';
import { Store } from '@ngrx/store';

@Injectable()
export class FormConfigGetter {
     constructor(private store: Store<IbundleData>) {
    }

    private storeAllFormsConfigs(forms: Array<any>) {
     // Todo server call with bundle all the forms
     this.store.dispatch({
        type: 'UPDATE_FORMS_CONFIGS',
        payload: forms
    });
    }

    public getAllFormsConfig(allWidgets: Array<any>) {
        const forms: Array<any> = new Array<any>();
        let currforms: any;
        const observableBatch = [];
        allWidgets.forEach(widget => {
            currforms = widget.forms;
            currforms.forEach(form => {
            if (!(forms.inArray(function (e) {
                return e === form.Id; // TODO right now its a string it can be more logic
            }))) {
                forms.push(form);
            }
           // observableBatch.push(this.store.select(getFormComfigByName(form.Id)));
        });
       // return combineLatest(...observableBatch);
    });
    this.storeAllFormsConfigs(forms);
}
}
